import classNames from 'classnames';
import React, { CSSProperties } from 'react';
import { getEventPageUrl } from '../../../../../../../components/PageReport/use-upload-file';
import useLogin from '../../../../../../../hooks/useLogin';
import { getBettweenAllDate } from '../../../../../../../utils/parse-date';
import share from './imgs/share.png';
import more from './imgs/more.png';
import icon_cycle from './imgs/icon_cycle.png';
import styles from './index.module.scss';
import { Dropdown, List, message } from '@tencent/tea-component';
import copyToClipboard from '@utils/copy-to-clipboard';

export interface LinkInviteProps {
  className?: string;
  style?: CSSProperties;
  /**
   * 主办方名称
   */
  hostName?: string;
  /**
   * 活动标题
   */
  eventTitle?: string;
  startTime?: number;
  endTime?: number;
  /**
   * 点击举报活动
   */
  onReportClick?: (isLogin?: boolean) => void;
}

const LinkInvite: React.FC<LinkInviteProps> = (props) => {
  const { className, style, hostName, eventTitle, startTime, endTime, onReportClick } = props;

  const { isLogin } = useLogin();

  const handleShareClick = () => {
    const url = getEventPageUrl();
    const dateTime = getBettweenAllDate(startTime!, endTime!);
    const text = `邀请您参加 ${hostName} 主办的活动，请点击下方链接查看详情。
活动主题：${eventTitle}
活动时间：${dateTime}
点击链接查看详情：${url}`;
    copyToClipboard(text);
    message.success({
      content: '活动邀请链接复制成功'
    });
  };

  return (
    <div className={classNames(styles.flexWrap, className)} style={style}>
      <div className={styles.shareBtn} onClick={handleShareClick}>
        <img className={styles.iconImg} src={share} alt="" loading={'lazy'} draggable={'false'} />
        <span>分享</span>
      </div>
      <Dropdown
        button={
          <div className={styles.moreBtn}>
            <img
              className={styles.moreImg}
              src={more}
              alt=""
              loading={'lazy'}
              draggable={'false'}
            />
          </div>
        }
        appearance="pure"
        trigger={'hover'}
      >
        <List type="option">
          <List.Item className={styles.listItem} onClick={() => {
            onReportClick?.(isLogin);
          }}>
            <img
              className={styles.listImg}
              src={icon_cycle}
              alt=""
              loading={'lazy'}
              draggable={'false'}
            />
            <p>举报活动</p>
          </List.Item>
        </List>
      </Dropdown>
    </div>
  );
};

export default LinkInvite;
